// Load an <img> from a URL for canvas export. crossOrigin='anonymous' keeps the
// canvas untainted so toBlob() works on S3 presigned prescription images
// (the bucket must return CORS headers for the admin origin).
export const loadImageElementFromUrl = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });
